import React, { useState } from 'react'
import {
  makeStyles,
  createStyles,
  // withStyles,
  Box,
  AppBar,
  fade,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Select,
} from '@material-ui/core'
import { Waypoint } from 'react-waypoint'
import classnames from 'classnames'
// import Logo from '../../../assets/images/logo_Hk.png'
// import { ReactComponent as ArrowRightFillIcon } from 'src/mobile/assets/icons/arrow-right-fill.svg'
import { MOBILE_HEADER_HEIGHT } from 'src/mobile/utils/constant'
// import useAuthRedirect from 'src/hooks/useAuthRedirect'
import { useTranslation } from 'react-i18next'
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined'
import EDrawer from 'src/mobile/themes/components/EDrawer'
import { ReactComponent as RightArrowIcon } from 'src/mobile/assets/icons/arrow-ios-right.svg'
import { ReactComponent as HomeIcon } from 'src/mobile/assets/icons/home.svg'
import { ReactComponent as CalendarFillIcon } from 'src/mobile/assets/icons/medical_services.svg'
import { ReactComponent as Promotion } from 'src/mobile/assets/icons/auto_awesome.svg'
import { ReactComponent as MyProfile } from 'src/mobile/assets/icons/myprofile.svg'

import { ReactComponent as FaqIcon } from 'src/mobile/assets/icons/faq.svg'
import { LANGUAGE_LIST } from 'src/i18n'
import useUserSession from 'src/hooks/useUserSession'
import { useImageTranslation } from 'src/hooks'
import { useDispatch } from 'react-redux'
import { setLanguage } from 'src/store/slices/authSlice'
// import EDialog from 'src/mobile/themes/components/EDialog'
// import { toast } from 'react-toastify'
import { ReactComponent as FooterIcon8 } from 'src/mobile/assets/icons/footer_icon8.svg'
import CallOutlinedIcon from '@material-ui/icons/CallOutlined'
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined'
import { ReactComponent as footerIcon3 } from 'src/mobile/assets/icons/wtap.svg'
import { ReactComponent as LanguageIcon } from 'src/mobile/assets/icons/footer_icon7.svg'
import { SERVICE_PHONE, SERVICE_EMAIL, SERVICE_WHATSAPP, SITE_MATE_DATA } from '../../../utils/constant'
import { useHistory, Link, useLocation } from 'react-router-dom'
import { changePathName } from 'src/utils/replaceURLs'
import { buttonClick } from 'src/utils/trackingCode'
// import Accordion from '@material-ui/core/Accordion'
// import AccordionSummary from '@material-ui/core/AccordionSummary'
// import AccordionDetails from '@material-ui/core/AccordionDetails'

const useStyles = makeStyles((theme) =>
  createStyles({
    listWrapper: {
      borderStartEndRadius: 12,
      borderStartStartRadius: 12,
      background: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${
        theme.palette.background.paper
      } 30%, ${fade(theme.palette.background.paper, 0)} 100%)`,
      padding: theme.spacing(2),
    },
    listItemIcon: {
      minWidth: 'auto',
      marginRight: theme.spacing(1),
    },
    listItem: {
      padding: theme.spacing(1.5, 0),
      marginBottom: theme.spacing(1.5),
    },
    content: {
      alignItems: 'center',
    },
    around: {
      boxShadow: 'none',
      borderRadius: 0,
    },
    listItemText: {
      fontSize: theme.spacing(2),
      fontWeight: 600,
    },
    languageListItemText: {
      display: 'flex',
      alignItems: 'center',
    },
    arrowIcon: {
      '& path': {
        fill: theme.palette.primary.main,
      },
    },
    logoutButton: {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.grey[100]}`,
      color: theme.palette.secondary.main,
      fontWeight: theme.typography.fontWeightBold,
      marginTop: theme.spacing(3),
      '&:hover': {
        backgroundColor: fade(theme.palette.background.paper, 0.8),
      },
    },
    profileBackground: {
      position: 'absolute',
      left: 0,
      width: '100%',
      bottom: 0,
      zIndex: 0,
      opacity: 0.7,
    },
    select: {
      width: '100%',
    },
    root: {
      backgroundColor: '#ffff',
      backdropFilter: `blur(10px)`,
      top: 0,
      height: theme.spacing(MOBILE_HEADER_HEIGHT),
    },
    logo: {
      width: theme.spacing(11),
      display: 'block',
    },
    arrowRightFillIcon: {
      width: theme.spacing(1.5),
      height: theme.spacing(1.5),
      '& path': {
        fill: theme.palette.primary.contrastText,
      },
    },
    withBg: {
      backgroundColor: fade(theme.palette.primary.main, 0.9),
      backdropFilter: `blur(10px)`,
    },
    icon8: {
      '& path': {
        fill: theme.palette.primary.main,
      },
    },
    list: {
      '&:last-child': {
        fontWeight: 500,
      },
    },
    icons: {
      fontSize: 20,
      '& path': {
        fill: theme.palette.grey[400],
      },
    },
    accordionSummary: {
      padding: 0,
    },
    accordionDetails: {
      flexDirection: 'column',
    },
    expandIcon: {
      transform: 'rotate(90deg)',
      '&.Mui-expanded': {
        transform: 'rotate(270deg)',
      },
    },
  }),
)
// const Accordion2 = withStyles((theme) => ({
//   root: {
//     backgroundColor: 'transparent',
//     boxShadow: 'none',
//     width: '100%',
//     height: 'auto !important',
//     '&.Mui-expanded': {
//       margin: 0,
//     },
//     '&.Mui-disabled': {
//       backgroundColor: 'transparent',
//       color: theme.palette.primary.contrastText,
//     },

//     '&:before': {
//       display: 'none',
//     },
//   },
//   collapseIcon: {
//     display: 'flex',
//     justifyContent: 'space-between',
//   },
// }))(Accordion)
const Header = ({ children }) => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  // const authRedirect = useAuthRedirect()
  const dispatch = useDispatch()
  const history = useHistory()
  const { pathname } = useLocation()

  const [tImage] = useImageTranslation()
  // const [withBg, setWithBg] = useState(true)
  const [open, setOpen] = useState(false)
  const handleClick = () => setOpen(true)
  const { userInfo, authenticated } = useUserSession()
  const handleChangeLanguage = async (e) => {
    const language = e.target.value
    language && i18n.changeLanguage(language)
    if (authenticated && userInfo?.id)
      await dispatch(setLanguage({ id: userInfo?.id, language: language })).unwrap()
    changePathName(language, history, pathname)
  }
  // const handleSignOut = () => {
  //   dispatch(signOut())
  //   toast.error(t('common.had_sign_out'))
  //   history.push('/')
  // }

  const FooterText = [
    {
      label: t('glossary.contact_us'),
      FooterText: [
        {
          label: SERVICE_PHONE,
          icon: CallOutlinedIcon,
          toTel: true,
          number: '+85236130533',
        },
        {
          label: SERVICE_WHATSAPP,
          icon: footerIcon3,
          toWhatsApp: true,
          number:
            i18n.language === 'zh-HK'
              ? SITE_MATE_DATA.WHATSAPP_PC_HK
              : i18n.language === 'en'
              ? SITE_MATE_DATA.WHATSAPP_PC_EN
              : SITE_MATE_DATA.WHATSAPP_PC_CN,
        },
        {
          label: SERVICE_EMAIL,
          icon: EmailOutlinedIcon,
          toMail: true,
        },
      ],
    },
  ]
  const PROFILE_LIST = [
    {
      label: t('glossary.homepage'),
      path: '/',
      icon: HomeIcon,
      auth: true,
    },
    {
      label: t('common.product_list'),
      path: '/ProductList',
      icon: CalendarFillIcon,
      auth: true,
    },
    {
      label: t('common.promotion_menu'),
      path: '/promotion',
      icon: Promotion,
    },
    {
      label: t('glossary.faq'),
      path: '/faq',
      icon: FaqIcon,
    },
  ]
  return (
    <>
      <Waypoint />
      <AppBar position="sticky" elevation={0} className={classnames(classes.root)}>
        <Box height="100%" mx={2.5} mb={1.625} mt={1.625} alignItems="center" display="flex">
          <img
            className={classes.logo}
            src={tImage('logo', 'png')}
            // src={Logo}
            alt="logo"
            onClick={() => history.push('/')}
          />
          <Box ml="auto" alignItems="center" display="flex" onClick={handleClick}>
            <MenuOutlinedIcon style={{ color: '#1A285D' }} />
            {/* <Box
              fontSize="body1.fontSize"
              fontWeight="fontWeightMedium"
              color="primary.contrastText"
              component="span"
            >
              {t('glossary.appointment_order')}
            </Box> */}
            {/* <ArrowRightFillIcon className={classes.arrowRightFillIcon} /> */}
          </Box>
        </Box>
        <EDrawer onClose={() => setOpen(false)} open={open} anchor="right">
          {authenticated ? (
            <Box px={2}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                to="/profile/account"
                component={Link}
                style={{ height: 56 }}
              >
                <MyProfile style={{ marginRight: 2 }} />
                {t('common.my_account')}
              </Button>
            </Box>
          ) : (
            <Box display="flex" justifyContent="center" px={2}>
              <Box width="100%" mr={2}>
                <Button variant="outlined" fullWidth to="/signin" component={Link}>
                  {t('common.sign_in')}
                </Button>
              </Box>
              <Box width="100%">
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  to="/signup"
                  component={Link}
                  onClick={() => {
                    buttonClick('EH_Menu_Reg', 'EH_Menu_Reg')
                  }}
                >
                  {t('common.signUp')}
                </Button>
              </Box>
            </Box>
          )}
          <Box className={classes.listWrapper}>
            <List disablePadding>
              {PROFILE_LIST?.map((item, index) => (
                <ListItem
                  data-path={item.path}
                  data-auth={item.auth}
                  onClick={() => {
                    history.push(item.path)
                    setOpen(false)
                  }}
                  className={classes.listItem}
                  key={item.label}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <item.icon />
                  </ListItemIcon>
                  {/* {index === 2 ? (
                    <Accordion2 classes={{ round: classes.round }}>
                      <AccordionSummary
                        expandIcon={<RightArrowIcon className={classes.arrowIcon} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        classes={{
                          root: classes.accordionSummary,
                          content: classes.content,
                          expandIcon: classes.expandIcon,
                        }}
                      >
                        <ListItemIcon className={classes.listItemIcon}>
                          <item.icon />
                        </ListItemIcon>
                        <Box className={classes.listItemText}>{item.label}</Box>
                      </AccordionSummary>
                      <AccordionDetails
                        classes={{
                          root: classes.accordionDetails,
                        }}
                      >
                        <Typography>
                          <Box fontSize={16} my={1} onClick={() => history.push('/promotion')}>
                            {t('glossary.all_promotion')}
                          </Box>
                          <Box
                            fontSize={16}
                            my={1}
                            onClick={() => history.push('/promotion', { value: '2' })}
                          >
                            {t('glossary.promotion_use_function')}
                          </Box>
                        </Typography>
                      </AccordionDetails>
                    </Accordion2>
                  ) : ( */}
                  <ListItemText
                    primary={
                      <Typography className={classes.listItemText} variant="h5" noWrap>
                        {t(item.label)}
                      </Typography>
                    }
                  />{' '}
                  <RightArrowIcon className={classes.arrowIcon} />
                  {/* // )} */}
                </ListItem>
              ))}

              <Box
                fontWeight={600}
                onClick={() => {
                  buttonClick('EH_Menu_CorpSite', 'EH_Menu_CorpSite')
                  window.open('https://take2health.net/')
                }}
                borderBottom="1px solid #E5E7EB "
                pb={1}
              >
                <Box display="flex">
                  <Box className={classnames(classes.listItemText, classes.languageListItemText)} mr={1}>
                    {t('glossary.web')}
                  </Box>
                  <FooterIcon8 className={classes.icon8} />
                </Box>
              </Box>
              <Box>
                {FooterText?.map((item, index) => (
                  <Box key={index} className={classes.list}>
                    <Box display="flex">
                      <Box mt={2} fontWeight={600} fontSize={14} color="grey.400">
                        {item.label}
                      </Box>
                    </Box>
                    <Box>
                      {item?.FooterText?.map((item, index) => (
                        <Box key={index} mt={2.25} display="flex">
                          <item.icon className={classes.icons} />
                          <Box
                            ml={1}
                            fontSize={14}
                            color="grey.400"
                            onClick={() => {
                              const buttonName = item?.toTel
                                ? 'EH_Menu_Phone'
                                : item?.toWhatsApp
                                ? 'EH_Menu_WhatsApp'
                                : item?.toMail
                                ? 'EH_Menu_email'
                                : ''
                              const buttonId = item?.toTel
                                ? 'EH_Menu_Phone'
                                : item?.toWhatsApp
                                ? 'EH_Menu_WhatsApp'
                                : item?.toMail
                                ? 'EH_Menu_email'
                                : ''
                              buttonClick(buttonName, buttonId)
                              item.openNew
                                ? window.open(item.url)
                                : item.toTel
                                ? (window.location.href = `tel:${item.number}`)
                                : item.toWhatsApp
                                ? (window.location.href = item.number)
                                : (window.location.href = `mailto:${item.label}`)
                            }}
                          >
                            {' '}
                            {item.label}
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
              <ListItem className={classes.listItem}>
                <ListItemText
                  primary={
                    <Typography
                      className={classnames(classes.listItemText, classes.languageListItemText)}
                      variant="h5"
                      noWrap
                    >
                      <LanguageIcon />
                      <Select
                        className={classnames(classes.listItemText)}
                        classes={{
                          root: classes.select,
                        }}
                        disableUnderline
                        native
                        defaultValue={i18n.language}
                        onChange={handleChangeLanguage}
                      >
                        {LANGUAGE_LIST.map((language, index) => (
                          <option key={language.lang + index} value={language.lang}>
                            {t(language.label)}
                          </option>
                        ))}
                      </Select>
                    </Typography>
                  }
                />
              </ListItem>
            </List>
            {/* {authenticated && (
              <EDialog
                title={t('are_you_sure.sign_out')}
                trigger={
                  <Button disableElevation className={classes.logoutButton} fullWidth variant="contained">
                    {t('common.sign_out')}
                  </Button>
                }
                onConfirm={handleSignOut}
              />
            )} */}
          </Box>
        </EDrawer>
      </AppBar>
    </>
  )
}

export default Header
